// 공통 로딩 상태 — 5 페이지에서 첫 fetch 대기 중에만 노출
// placeholderData가 있으면 isLoading=false라 사실상 거의 안 보임

export function LoadingState({ label = "불러오는 중…" }: { label?: string }) {
  return (
    <div
      style={{
        padding: "48px 16px",
        textAlign: "center",
        color: "var(--cs-mute)",
        fontSize: 14,
        lineHeight: 1.6,
      }}
      role="status"
      aria-live="polite"
    >
      <div data-g-allow-border="spinner" 
        aria-hidden
        style={{
          width: 32,
          height: 32,
          border: "3px solid var(--cs-line)",
          borderTopColor: "var(--cs-accent)", // 모바일 정본 토큰(구 --accent 폴백은 웹 토큰 · 2026-09-03)
          borderRadius: "50%",
          margin: "0 auto 12px",
          animation: "sotda-spin 0.8s linear infinite",
        }}
      />
      <div>{label}</div>
      <style>{`@keyframes sotda-spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
